// Cookies carry the session. The in-memory CSRF value is not a login credential.
(() => {
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (input, init = {}) => {
        const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
        const local = url.origin === window.location.origin;
        const protectedRequest = local && /^\/(?:api|data|uploads|email|upload)(?:\/|$)/.test(url.pathname);
        const auth = window.AuthManager;
        const epoch = auth?._epoch;
        let options = init;
        if (protectedRequest) {
            const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
            headers.delete('Authorization');
            headers.set('X-SICAF-Request','1');
            const csrf = auth?.getCsrfToken();
            if (csrf) headers.set('X-SICAF-CSRF',csrf);
            options = {...init,headers,credentials:'same-origin',cache:'no-store',redirect:'error'};
        }
        const response = await originalFetch(input, options);
        if (protectedRequest) {
            // «Actualización en curso»: cover the app at once instead of waiting for the next check.
            if (response.status === 503 && response.headers.get('x-sicaf-maintenance')) window.UpdateWatch?.show();
            if (auth && epoch !== auth._epoch) throw new Error('La sesión ha cambiado. Recarga los datos.');
            const csrf = response.headers.get('x-sicaf-csrf');
            if (csrf && auth) auth.csrfToken = csrf;
            if (response.status === 401 && auth?.isLoggedIn() && !['/api/login','/api/logout'].includes(url.pathname) && !url.pathname.startsWith('/api/public/')) {
                auth.logoutSilently();
                auth.redirectToStart();
            }
        }
        return response;
    };
    window.addEventListener('pagehide', () => {document.body.style.visibility='hidden';});
    window.addEventListener('pageshow', event => {if(event.persisted)window.location.reload();});
})();
